import { FC, useEffect, useState } from "react";
import FileListWrap from "./style";
import { Button, Empty, Flex, Image, notification, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { docFetchs } from "@/apis/doc";
import { getFileUrl } from "@/apis/file";
import { AreaEnum, User } from "@/types/user";
import { Doc, DocTypeEnum } from "@/types/doc";
import { getUserAvatarTip, getUserName } from "@/utils/user";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadFile } from "../SDoc/utils";
import WMSAvatar from "@/styles/WMSAvatar";

interface WDocFileListTabProps {
  docList: string[];
};

interface FileData {
  id: string;
  name: string;
  suffix: string;
  creator: User;
}

// 递归提取树中所有 LEAF 节点（即文件）
const extractLeafDocs = (docs: Doc[], result: FileData[] = []): FileData[] => {
  docs.forEach((doc) => {
    if (doc.nodeType === DocTypeEnum.LEAF) {
      result.push({
        id: doc.fileId,
        name: doc.name,
        suffix: doc.suffix,
        creator: doc.creator,
      });
    }
    if (doc.subs?.length) extractLeafDocs(doc.subs, result);
  });
  return result;
};
const WDocFileListTab: FC<WDocFileListTabProps> = ({ docList }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [fileList, setFileList] = useState<FileData[]>([]);

  useEffect(() => {
    if (!!docList?.length) initFileList();
  }, [docList]);

  const initFileList = async () => {
    try {
      setLoading(true);
      let docs = await docFetchs(docList);
      if (!!docs?.length) setFileList(extractLeafDocs(docs));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification.error({ message: t('counting.loadFailed') });
    }
  };

  return (
    <FileListWrap>
      {loading && <Flex justify='center' align='center' className="spin-box"><Spin spinning /></Flex>}
      {
        !loading && (
          fileList.length ? (
            <Image.PreviewGroup>
              {
                fileList.map(file => (
                  <Flex align='center' gap={6} className="file-box">
                    <Image src={getFileUrl(file.id)} width={60} height={60} />
                    <Flex vertical gap={6} className="name-box" flex={1}>
                      <span>{file.name}</span>
                      <Flex gap={4} align='center'>
                        <WMSAvatar uniChar={file.creator.id}
                          avatarId={file.creator.avatar}
                          creator={file.creator} size={26}
                          alt={getUserAvatarTip(file.creator)} />
                        <span>{getUserName(file.creator)}</span>
                      </Flex>
                    </Flex>
                    <Button icon={<DownloadOutlined />} onClick={() => downloadFile(file.id)} />
                  </Flex>
                ))
              }
            </Image.PreviewGroup>
          ) : (
            <Empty />
          )
        )
      }
    </FileListWrap>
  )
};

export default WDocFileListTab;